module.exports = __webpack_public_path__ + "static/img/main.100636e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main.svg
// module id = xkwv
// module chunks = 1